import React, { useRef } from "react";
import "./GalleryPage.css";
import {
  galleryData,
  reviewsData,
} from "../Datas/galleryData";




const GalleryPage = () => {
  const scrollRef = useRef();

  const scroll = (direction) => {
    if (direction === "left") {
      scrollRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    } else {
      scrollRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <div className="gallery-page">

        {/* TITLE */}
        <h2 className="gallery-title">PHOTO GALLERY</h2>

        {/* GALLERY */}
        <div className="gallery-wrapper">

          <button
            className="arrow left"
            onClick={() => scroll("left")}
          >
            ❮
          </button>

          <div className="gallery-container" ref={scrollRef}>
            {galleryData.map((item, index) => (
              <div className="gallery-card" key={index}>
                <img src={item.img} alt="" />

                
              </div>
            ))}
          </div>

          <button
            className="arrow right"
            onClick={() => scroll("right")}
          >
            ❯
          </button>

        </div>

        {/* FEEDBACK */}
        <h2 className="feedback-title">
          RECENT FEEDBACK
        </h2>

        <div className="feedback-container">

          {reviewsData.map((review, index) => (
            <div className="feedback-card" key={index}>

              <div className="feedback-avatar"></div>

              <div className="feedback-content">
                <h3>{review.name}</h3>
                <p>{review.message}</p>
              </div>

              <div className="stars">
                {review.rating.toFixed(1)} ★
              </div>

            </div>
          ))}

        </div>
      </div>
    </>
  );
};

export default GalleryPage;